import React from 'react';
import {NodeProps} from 'reactflow';

import {RouterNodeData} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';
import {BenchlingNodeV2} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNode';

import {createHeaderPropsForNode} from './nodeUtils';

export default function RouterNodeRenderer(props: NodeProps<RouterNodeData>): JSX.Element {
  const {data, id} = props;
  const {isDisabled, status, onNodeHeaderClick} = data;

  const finalHeaderProps = createHeaderPropsForNode(data);

  const handleHeaderClick = (): void => {
    onNodeHeaderClick?.(id);
  };

  return (
    <div onClick={handleHeaderClick} style={{cursor: onNodeHeaderClick != null ? 'pointer' : 'default'}}>
      <BenchlingNodeV2.Standard.Node isDisabled={isDisabled} status={status} headerProps={finalHeaderProps} />
    </div>
  );
}
